export default {
  baseStyle: { fontWeight: "900" },
  // defaultProps: {size},
  // sizes: {}
}
